<mp-navigation-item
  #link
  [path]="navigationGroup().route"
  [icon]="navigationGroup().icon"
  [label]="navigationGroup().label"
  [isExpanded]="isExpanded()"
  [isParentItem]="!!children().length"
  [matTooltip]="tooltipMessage()"
  matTooltipClass="{{ class }}__navigation-menu-tooltip"
  matTooltipPosition="right"
  (itemClick)="trackItemClick(navigationGroup().label)"
/>

@if (children().length) {
  <div
    #groupcontent
    class="group-content"
    [class]="{
      'group-content--subitems-mode': isExpanded() && isActive(),
      'group-content--submenu-mode': !isExpanded() && isSubmenuVisible(),
    }"
    (click)="hideGroupSubmenu()"
  >
    <span class="group-content__label">{{ navigationGroup().label }}</span>

    @for (childItem of children(); track $index) {
      <mp-navigation-item
        [path]="navigationGroup().route + '/' + childItem.route"
        [icon]="childItem.icon"
        [label]="childItem.label"
        [isChildItem]="true"
        [isExpanded]="isExpanded()"
        (itemClick)="trackChildItemClick(navigationGroup().label, childItem.label)"
      />
    }
  </div>
}
